<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage Rooms</p>
    </header>
    <section class="modal-card-body">
      
      <b-tabs type="is-boxed" expanded>
           <b-tab-item label="Room Details">
           <div class="columns">
           <div class="column">
        <b-field label="Select Season">
           <b-select placeholder="High" 
           icon="snowflake" 
           expanded  
           v-model="selectedSeason1"
           @input="changeSeasonSelected"
            >
           <option 
           v-for="season in seasons" 
           v-bind:key="season.label" 
           v-bind:value="season">{{season.label}}
        </option>
        </b-select>
        </b-field>
        </div>
                      <div class="column">
                      <b-field label="Room Name">
                      <b-input  type="text" placeholder="Dulex" icon="hotel"  v-bind:valu="name" v-model="name"> </b-input>
                      </b-field>
                      </div>
                      </div>
                      <div class="columns">
                      <div class="column">
                      <b-field label="Adult">
                      <b-input  type="number" placeholder="Adult" icon="rupee-sign" v-model.number="rates.adult"> </b-input>
                      </b-field>
                      </div>  
                      <div class="column">
                      <b-field label="Child With Bed">
                      <b-input  type="number" placeholder="Child With Bed" icon="rupee-sign" v-model.number="rates.child"> </b-input>
                      </b-field> 
                      </div> 
                      </div> 
                      <div class="columns">
                      <div class="column">
                      <b-field label="Child Without Bed">
                      <b-input  type="number" placeholder="Child Without Bed" icon="rupee-sign" v-model.number="rates.childWithoutBed"> </b-input>
                      </b-field> 
                      </div> 
                      <div class="column">
                      <b-field label="Extra Adult">
                      <b-input  type="number" placeholder="2000" icon="rupee-sign" v-model.number="rates.extraAdult"> </b-input>
                      </b-field>
                      </div> 
                      </div> 
                         <div class="columns">
                           <div class="column">
                      <b-field label="Service Charge">
                      <b-input  type="number" placeholder="50" icon="rupee-sign" v-model.number="serviceCharge"> </b-input>
                      </b-field> </div>
                      </div> 
        </b-tab-item >

        <b-tab-item label="Mealplan Details">
               <div class="columns">
                <div class="column is-8">
                      <b-field label="Mealplan Name">
                      <b-input  type="text" placeholder="Breakfast only" icon="utensils" v-model="mealplanList.name"> </b-input>
                      </b-field>
                </div>
                 <div class="column is-4">
                    <b-field label="Add">
                    <button class="button is-link meal-button" @click="addMealplan()"><font color="white">+</font></button>
                    </b-field>
                </div>
                </div>
             <div class="columns">
                      <div class="column">
                      <b-field label="Adult">
                      <b-input  type="number" placeholder="Adult" icon="rupee-sign" v-model.number="mealplanList.adult"> </b-input>
                      </b-field>
                      </div>  
                      <div class="column">
                      <b-field label="Child With Bed">
                      <b-input  type="number" placeholder="Child With Bed" icon="rupee-sign" v-model.number="mealplanList.CWB"> </b-input>
                      </b-field> 
                      </div>  </div>     <div class="columns">
                      <div class="column">
                      <b-field label="Child Without Bed">
                      <b-input  type="number" placeholder="Child Without Bed" icon="rupee-sign" v-model.number="mealplanList.CWOB"> </b-input>
                      </b-field> 
                      </div> 
                      <div class="column">
                      <b-field label="Extra Adult">
                      <b-input  type="number" placeholder="Extra Adult" icon="rupee-sign" v-model.number="mealplanList.Xadult"> </b-input>
                      </b-field>
                      </div> </div> 
                 <hr >
                 <div v-if="!room.mealPlans">Loading Please wait...</div>
                 <div v-else >
              <div class="card" v-for='(meal, index) in room.mealPlans' :key="meal.name">
                 <header class="card-header">
                    <div class="card-header-title">  <strong> {{name}} room with {{meal.name}} </strong></div>
                      <b-tooltip label="Delete Mealplan" position="is-left">
                         <a  class="card-header-icon" aria-label="Delete Mealplan" @click="removeMealplan(index)">
                            <span class="icon">
                               <i class="far fa-trash-alt"></i>
                            </span>
                         </a> 
                      </b-tooltip> 
                 </header>
                    <div class="card-content">
                       <div class="content">
                   <div class="columns">
                   <div class="column is-fullwedithed">
                   <b-field label="Mealplan Name">
                   <b-input  type="text" placeholder="Breakfast only" icon="utensils" v-model="meal.name"> </b-input>
                   </b-field>
                   </div>
  
                 </div>
                 <div class="columns">
                      <div class="column">
                      <b-field label="Adult">
                      <b-input  type="number" placeholder="Adult" icon="rupee-sign" v-model.number="meal.rates.adult"> </b-input>
                      </b-field>
                      </div>  
                      <div class="column">
                      <b-field label="Child With Bed">
                      <b-input  type="number" placeholder="Child With Bed" icon="rupee-sign" v-model.number="meal.rates.child"> </b-input>
                      </b-field> 
                      </div>  </div>   <div class="columns">
                      <div class="column">
                      <b-field label="Child Without Bed">
                      <b-input  type="number" placeholder="Child Without Bed" icon="rupee-sign" v-model.number="meal.rates.childWithoutBed"> </b-input>
                      </b-field> 
                      </div> 
                      <div class="column">
                      <b-field label="Extra Adult">
                      <b-input  type="number" placeholder="Extra Adult" icon="rupee-sign" v-model.number="meal.rates.extraAdult"> </b-input>
                      </b-field>
                      </div> </div>
                       </div> </div>
                         <hr >
               </div> </div>
        </b-tab-item>
      </b-tabs>
              
    </section>
    <footer class="modal-card-foot">
      
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageRoom">Save</button>
    </footer>
  </div>
</template>

<script>
import RoomService from "./service";
import Firebase from '../../../lib/Firebase';
import Firestore from '../../../lib/Firestore';
export default {
  name: "manageRooms",

  props: ["propRoom", "city"],

  created() {
     this.fetchSeasons();
     
    if (this.propRoom.docId) {
    this.room = { ...this.propRoom };
    
      this.id = this.room.docId;
      //console.log("Prop" , this.id)
      this.name =  this.room.name;
      this.rates =  this.room.rates;
      this.serviceCharge =  this.room.serviceCharge;
      this.mealPlans =  this.room.mealPlans
     // console.log("Mealplans :" , this.room.mealPlans);
      
    }  
 
  },

  data() {
    return {
      isLoading: false,
      id: null,
      docId: null,
      name: null,
      serviceCharge : null,
      rates : {},
      seasons : null,
      room : null,
      mealplanList : {},
      room :{
          mealPlans : []
      },
      rooms : null,
      selectedSeason1 : null,
      room_name : null,
      adult: null,
      CWB: null,
      CWOB: null,
      Xadult: null
    };
  },

  methods: {
        fetchSeasons() {
      RoomService.al(this.city).then(data => {
        this.seasons = data;
        this.isLoading = false;
       // console.log(this.seasons);
      });
    },
     selectedSeason(season) {
               return this.selectedSeason1 && this.selectedSeason1.docId === season.docId;
               // console.log(this.season.docId);
            },
      changeSeasonSelected(season) {
      this.selectedSeason1 = season;
      console.log("Drop", season);
      this.$bus.$emit('SEASON_CHANGED', season);
      this.$toast.open({
                    message: 'Current season updated!',
                    position: 'is-top',
                    type: 'is-success'
            });
    },
    manageRoom() {
    this.isLoading = true;
      RoomService.manage(this.id, this.selectedSeason1, this.name, this.rates, this.serviceCharge, this.room.mealPlans).then(() => {
       this.isLoading = false;
        this.$toast.open("Saved successfully");
        this.$emit("close");
      });
    },
     addMealplan() {
      if (!this.room.mealPlans) {
        this.room.mealPlans = [];  
      }
      this.room.mealPlans.push({
        name: this.mealplanList.name,
        rates : { adult: this.mealplanList.adult,
        child: this.mealplanList.CWB,
        childWithoutBed : this.mealplanList.CWOB,
        extraAdult : this.mealplanList.Xadult,
        infant : 0 }
      });
       this.mealplanList = {};
    },
     removeMealplan(index) {
      this.room.mealPlans.splice(index, 1);
      this.mealplanList = {};
    },
  }
};
</script>
<style scoped>
#mealplan {
  background-color: blue;
}
</style>



// WEBPACK FOOTER //
// src/pages/hotel/Rooms/ManageRooms.vue